export default __webpack_public_path__ + "static/media/lider2.b5875448.png";